import * as types from "../constants/action_types";

export const STOP_LOADER = {
  type: "STOP_LOADER",
  payload: false,
};
/* Auth-(login/logout) Actions Start */
export const LOGIN_REQ = (payload) => ({
  type: types.LOGIN_REQ,
  payload,
});

export const LOGIN_SUCCESS = (payload) => ({
  type: types.LOGIN_SUCCESS,
  payload,
});

export const LOGOUT_REQ = (payload) => ({
  type: types.LOGOUT_REQ,
  payload,
});

export const LOGOUT_SUCCESS = (payload) => ({
  type: types.LOGOUT_SUCCESS,
  payload,
});

export const LOGIN_ERROR = (error) => ({
  type: types.LOGIN_ERROR,
  error,
});
/* Auth-(login/logout) Actions end */

/* Customer Actions Start */
export const CREATECOMPANY_REQ = (payload) => ({
  type: types.CREATECOMPANY_REQ,
  payload,
});

export const CREATECOMPANY_RESPONSE = (payload) => ({
  type: types.CREATECOMPANY_RESPONSE,
  payload,
});

export const EDITCOMPANY_REQ = (payload) => ({
  type: types.EDITCOMPANY_REQ,
  payload,
});

export const EDITCOMPANY_RESPONSE = (payload) => ({
  type: types.EDITCOMPANY_RESPONSE,
  payload,
});

export const UPDATEMODULES_REQ = (payload) => ({
  type: types.UPDATEMODULES_REQ,
  payload,
});

export const UPDATEMODULES_RESPONSE = (payload) => ({
  type: types.UPDATEMODULES_RESPONSE,
  payload,
});

export const GETCOMPANIES_REQ = (payload) => ({
  type: types.GETCOMPANIES_REQ,
  payload,
});

export const GETCOMPANIES_RESPONSE = (payload) => ({
  type: types.GETCOMPANIES_RESPONSE,
  payload,
});
export const GETCOMPANY_REQ = (payload) => ({
  type: types.GETCOMPANY_REQ,
  payload,
});

export const GETCOMPANY_RESPONSE = (payload) => ({
  type: types.GETCOMPANY_RESPONSE,
  payload,
});

export const GETCOMPANYUSER_REQ = (payload) => ({
  type: types.GETCOMPANYUSER_REQ,
  payload,
});

export const GETCOMPANYUSER_RESPONSE = (payload) => ({
  type: types.GETCOMPANYUSER_RESPONSE,
  payload,
});

export const GETCOMPANYUSERSTAT_REQ = (payload) => ({
  type: types.GETCOMPANYUSERSTAT_REQ,
  payload,
});

export const GETCOMPANYUSERSTAT_RESPONSE = (payload) => ({
  type: types.GETCOMPANYUSERSTAT_RESPONSE,
  payload,
});

export const GETSUBSCRIPTIONS_REQ = (payload) => ({
  type: types.GETSUBSCRIPTIONS_REQ,
  payload,
});

export const GETSUBSCRIPTIONS_RESPONSE = (payload) => ({
  type: types.GETSUBSCRIPTIONS_RESPONSE,
  payload,
});

export const TOGGLESUBSCRIPTION_REQ = (payload) => ({
  type: types.TOGGLESUBSCRIPTION_REQ,
  payload,
});

export const TOGGLESUBSCRIPTION_RESPONSE = (payload) => ({
  type: types.TOGGLESUBSCRIPTION_RESPONSE,
  payload,
});


export const SYNCSUBSCRIPTION_REQ = (payload) => ({
  type: types.SYNCSUBSCRIPTION_REQ,
  payload,
});

export const SYNCSUBSCRIPTION_RESPONSE = (payload) => ({
  type: types.SYNCSUBSCRIPTION_RESPONSE,
  payload,
});

export const GETSUBSCRIPTION_ITEMS_REQ = (payload) => ({
  type: types.GETSUBSCRIPTION_ITEMS_REQ,
  payload,
});

export const GETSUBSCRIPTION_ITEMS_RESPONSE = (payload) => ({
  type: types.GETSUBSCRIPTION_ITEMS_RESPONSE,
  payload,
});

export const EDITSUBSCRIPTION_REQ = (payload) => ({
  type: types.EDITSUBSCRIPTION_REQ,
  payload,
});

export const EDITSUBSCRIPTION_RESPONSE = (payload) => ({
  type: types.EDITSUBSCRIPTION_RESPONSE,
  payload,
});

export const CREATESUBSCRIPTION_REQ = (payload) => ({
  type: types.CREATESUBSCRIPTION_REQ,
  payload,
});

export const CREATESUBSCRIPTION_RESPONSE = (payload) => ({
  type: types.CREATESUBSCRIPTION_RESPONSE,
  payload,
});

export const GETUSAGE_REQ = (payload) => ({
  type: types.GETUSAGE_REQ,
  payload,
});

export const GETUSAGE_RESPONSE = (payload) => ({
  type: types.GETUSAGE_RESPONSE,
  payload,
});

export const GETMODULES_REQ = (payload) => ({
  type: types.GETMODULES_REQ,
  payload,
});

export const GETMODULES_RESPONSE = (payload) => ({
  type: types.GETMODULES_RESPONSE,
  payload,
});

export const GETCOWORKERS_REQ = (payload) => ({
  type: types.GETCOWORKERS_REQ,
  payload,
});

export const GETCOWORKERS_RESPONSE = (payload) => ({
  type: types.GETCOWORKERS_RESPONSE,
  payload,
});

export const GETACTIVITY_REQ = (payload) => ({
  type: types.GETACTIVITY_REQ,
  payload,
});

export const GETACTIVITY_RESPONSE = (payload) => ({
  type: types.GETACTIVITY_RESPONSE,
  payload,
});

export const TOGGLECOMPANY_REQ = (payload) => ({
  type: types.TOGGLECOMPANY_REQ,
  payload,
});

export const TOGGLECOMPANY_RESPONSE = (payload) => ({
  type: types.TOGGLECOMPANY_RESPONSE,
  payload,
});

export const GETALLMODULES_REQ = (payload) => ({
  type: types.GETALLMODULES_REQ,
  payload,
});

export const GETALLMODULES_RESPONSE = (payload) => ({
  type: types.GETALLMODULES_RESPONSE,
  payload,
});

export const TOGGLEUSER_REQ = (payload) => ({
  type: types.TOGGLEUSER_REQ,
  payload,
});

export const TOGGLEUSER_RESPONSE = (payload) => ({
  type: types.TOGGLEUSER_RESPONSE,
  payload,
});

export const UPDATEUSERBILLING_REQ = (payload) => ({
  type: types.UPDATEUSERBILLING_REQ,
  payload,
});

export const UPDATEUSERBILLING_RESPONSE = (payload) => ({
  type: types.UPDATEUSERBILLING_RESPONSE,
  payload,
});

export const LOGINASUSER_REQ = (payload) => ({
  type: types.LOGINASUSER_REQ,
  payload,
});

export const LOGINASUSER_RESPONSE = (payload) => ({
  type: types.LOGINASUSER_RESPONSE,
  payload,
});

export const GETCOMPANYPOLICY_REQ = (payload) => ({
  type: types.GETCOMPANYPOLICY_REQ,
  payload,
});

export const GETCOMPANYPOLICY_RESPONSE = (payload) => ({
  type: types.GETCOMPANYPOLICY_RESPONSE,
  payload,
});

export const EDITCOMPANYPOLICY_REQ = (payload) => ({
  type: types.EDITCOMPANYPOLICY_REQ,
  payload,
});

export const EDITCOMPANYPOLICY_RESPONSE = (payload) => ({
  type: types.EDITCOMPANYPOLICY_RESPONSE,
  payload,
});

export const GETNOTES_REQ = (payload) => ({
  type: types.GETNOTES_REQ,
  payload,
});

export const GETNOTES_RESPONSE = (payload) => ({
  type: types.GETNOTES_RESPONSE,
  payload,
});

export const SAVENOTE_REQ = (payload) => ({
  type: types.SAVENOTE_REQ,
  payload,
});

export const SAVENOTE_RESPONSE = (payload) => ({
  type: types.SAVENOTE_RESPONSE,
  payload,
});

export const EDITNOTE_REQ = (payload) => ({
  type: types.EDITNOTE_REQ,
  payload,
});

export const EDITNOTE_RESPONSE = (payload) => ({
  type: types.EDITNOTE_RESPONSE,
  payload,
});

export const DELETENOTE_REQ = (payload) => ({
  type: types.DELETENOTE_REQ,
  payload,
});

export const DELETENOTE_RESPONSE = (payload) => ({
  type: types.DELETENOTE_RESPONSE,
  payload,
});

export const GETINTEGRATIONS_REQ = (payload) => ({
  type: types.GETINTEGRATIONS_REQ,
  payload,
});

export const GETINTEGRATIONS_RESPONSE = (payload) => ({
  type: types.GETINTEGRATIONS_RESPONSE,
  payload,
});

export const GETCREDENTIALS_REQ = (payload) => ({
  type: types.GETCREDENTIALS_REQ,
  payload,
});

export const GETCREDENTIALS_RESPONSE = (payload) => ({
  type: types.GETCREDENTIALS_RESPONSE,
  payload,
});

export const GETCREDENTIAL_REQ = (payload) => ({
  type: types.GETCREDENTIAL_REQ,
  payload,
});

export const GETCREDENTIAL_RESPONSE = (payload) => ({
  type: types.GETCREDENTIAL_RESPONSE,
  payload,
});
export const EDITCREDENTIAL_REQ = (payload) => ({
  type: types.EDITCREDENTIAL_REQ,
  payload,
});

export const EDITCREDENTIAL_RESPONSE = (payload) => ({
  type: types.EDITCREDENTIAL_RESPONSE,
  payload,
});

export const DELETECREDENTIAL_REQ = (payload) => ({
  type: types.DELETECREDENTIAL_REQ,
  payload,
});

export const DELETECREDENTIAL_RESPONSE = (payload) => ({
  type: types.DELETECREDENTIAL_RESPONSE,
  payload,
});


export const ADDCREDENTIAL_REQ = (payload) => ({
  type: types.ADDCREDENTIAL_REQ,
  payload,
});

export const ADDCREDENTIAL_RESPONSE = (payload) => ({
  type: types.ADDCREDENTIAL_RESPONSE,
  payload,
});

export const GETCOMPANYSTAT_REQ = (payload) => ({
  type: types.GETCOMPANYSTAT_REQ,
  payload,
});

export const GETCOMPANYSTAT_RESPONSE = (payload) => ({
  type: types.GETCOMPANYSTAT_RESPONSE,
  payload,
});

export const GETCOMPANYINVOICE_REQ = (payload) => ({
  type: types.GETCOMPANYINVOICE_REQ,
  payload,
});

export const GETCOMPANYINVOICE_RESPONSE = (payload) => ({
  type: types.GETCOMPANYINVOICE_RESPONSE,
  payload,
});



/* Customer Actions end */

/* Coworker Actions start */
export const TOGGLECOWORKER_REQ = (payload) => ({
  type: types.TOGGLECOWORKER_REQ,
  payload,
});

export const TOGGLECOWORKER_RESPONSE = (payload) => ({
  type: types.TOGGLECOWORKER_RESPONSE,
  payload,
});

export const DELETECOWORKER_REQ = (payload) => ({
  type: types.DELETECOWORKER_REQ,
  payload,
});

export const DELETECOWORKER_RESPONSE = (payload) => ({
  type: types.DELETECOWORKER_RESPONSE,
  payload,
});

export const RESETCOWORKERPWD_REQ = (payload) => ({
  type: types.RESETCOWORKERPWD_REQ,
  payload,
});

export const RESETCOWORKERPWD_RESPONSE = (payload) => ({
  type: types.RESETCOWORKERPWD_RESPONSE,
  payload,
});

export const CREATECOWORKER_REQ = (payload) => ({
  type: types.CREATECOWORKER_REQ,
  payload,
});

export const CREATECOWORKER_RESPONSE = (payload) => ({
  type: types.CREATECOWORKER_RESPONSE,
  payload,
});
export const EDITCOWORKER_REQ = (payload) => ({
  type: types.EDITCOWORKER_REQ,
  payload,
});

export const EDITCOWORKER_RESPONSE = (payload) => ({
  type: types.EDITCOWORKER_RESPONSE,
  payload,
});

export const GETCOWORKER_REQ = (payload) => ({
  type: types.GETCOWORKER_REQ,
  payload,
});

export const GETCOWORKER_RESPONSE = (payload) => ({
  type: types.GETCOWORKER_RESPONSE,
  payload,
});

export const GETCOWORKERCOMPANIES_REQ = (payload) => ({
  type: types.GETCOWORKERCOMPANIES_REQ,
  payload,
});

export const GETCOWORKERCOMPANIES_RESPONSE = (payload) => ({
  type: types.GETCOWORKERCOMPANIES_RESPONSE,
  payload,
});

export const COWORKERCOMPANY_REQ = (payload) => ({
  type: types.COWORKERCOMPANY_REQ,
  payload,
});
export const COWORKERCOMPANY_RESPONSE = (payload) => ({
  type: types.COWORKERCOMPANY_RESPONSE,
  payload,
});

export const RESET2FA_REQ = (payload) => ({
  type: types.RESET2FA_REQ,
  payload,
});

export const RESET2FA_RESPONSE = (payload) => ({
  type: types.RESET2FA_RESPONSE,
  payload,
});

export const RESENDONBOARDINGLINK_REQ = (payload) => ({
  type: types.RESENDONBOARDINGLINK_REQ,
  payload,
});

export const RESENDONBOARDINGLINK_RESPONSE = (payload) => ({
  type: types.RESENDONBOARDINGLINK_RESPONSE,
  payload,
});
/* Coworker Actions end */

/*Master data actions start*/
export const GETINDUSTRY_REQ = (payload) => ({
  type: types.GETINDUSTRY_REQ,
  payload,
});

export const GETINDUSTRY_RESPONSE = (payload) => ({
  type: types.GETINDUSTRY_RESPONSE,
  payload,
});

export const GETREGION_REQ = (payload) => ({
  type: types.GETREGION_REQ,
  payload,
});

export const GETREGION_RESPONSE = (payload) => ({
  type: types.GETREGION_RESPONSE,
  payload,
});
/*Master data actions end*/

/* Utils Action start */
export const SAVE_TO_LOCAL = (items) => ({
  type: types.SAVE_TO_LOCAL,
  items,
});

export const CLEAR_FROM_LOCAL = (keys) => ({
  type: types.CLEAR_FROM_LOCAL,
  keys,
});

export const GET_COMPANY_POLICY_FIELDS_REQ = () => ({
  type: types.GET_COMPANY_POLICY_FIELDS_REQ,
});

export const GET_COMPANY_POLICY_FIELDS_RESPONSE = (payload) => ({
  type: types.GET_COMPANY_POLICY_FIELDS_RESPONSE,
  payload,
});

export const GET_COMPANY_ZUPER_PAY_DETAILS_REQ = (payload) => ({
  type: types.GET_COMPANY_ZUPER_PAY_DETAILS_REQ,
  payload
});

export const GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE = (payload) => ({
  type: types.GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE,
  payload,
});


export const EDIT_ZUPER_PAY_REQ = (payload) => ({
  type: types.EDIT_ZUPER_PAY_REQ,
  payload,
});


export const EDIT_ZUPER_PAY_RESPONSE = (payload) => ({
  type: types.EDIT_ZUPER_PAY_RESPONSE,
  payload,
});

export const GET_WORK_BUILDER_NODE_FILTERS_REQ = (payload) => ({
  type: types.GET_WORK_BUILDER_NODE_FILTERS_REQ,
  payload: payload
});

export const GET_WORK_BUILDER_NODE_FILTERS_RESP = (payload) => ({
  type: types.GET_WORK_BUILDER_NODE_FILTERS_RESP,
  payload,
});

// Zuper Connect API
export const GET_CONNECT_PROVIDER_REQ = (payload) => ({
  type: types.GET_CONNECT_PROVIDER_REQ,
  payload: payload
});

export const GET_CONNECT_PROVIDER_RES = (payload) => ({
  type: types.GET_CONNECT_PROVIDER_RES,
  payload,
});

export const GET_CONNECT_AGENT_REQ = (payload) => ({
  type: types.GET_CONNECT_AGENT_REQ,
  payload: payload
});

export const GET_CONNECT_AGENT_RES = (payload) => ({
  type: types.GET_CONNECT_AGENT_RES,
  payload,
});

export const ADD_CONNECT_PROVIDER_REQ = (payload) => ({
  type: types.ADD_CONNECT_PROVIDER_REQ,
  payload: payload
});

export const ADD_CONNECT_PROVIDER_RES = (payload) => ({
  type: types.ADD_CONNECT_PROVIDER_RES,
  payload: payload
});

export const ADD_CONNECT_AGENT_REQ = (payload) => ({
  type: types.ADD_CONNECT_AGENT_REQ,
  payload,
});

export const ADD_CONNECT_AGENT_RES = (payload) => ({
  type: types.ADD_CONNECT_AGENT_RES,
  payload: payload
});

// Zuper Fleet API
export const ADD_FLEET_AUTH_REQ = (payload) => ({
  type: types.ADD_FLEET_AUTH_REQ,
  payload,
});

export const ADD_FLEET_AUTH_RESPONSE = (payload) => ({
  type: types.ADD_FLEET_AUTH_RESPONSE,
  payload,
});

/* Utils Action end */

/* Reset redux state */
export const RESET_STATE = (key, value = "") => ({
  type: types.RESET_STATE,
  key,
  value,
});


/*Migration*/
export const GETMIGRATION_REQ = (payload) => ({
  type: types.GETMIGRATION_REQ,
  payload,
});

export const GETMIGRATION_RESPONSE = (payload) => ({
  type: types.GETMIGRATION_RESPONSE,
  payload,
});

export const GETMIGRATIONDETAILS_REQ = (payload) => ({
  type: types.GETMIGRATIONDETAILS_REQ,
  payload,
});

export const GETMIGRATIONDETAILS_RESPONSE = (payload) => ({
  type: types.GETMIGRATIONDETAILS_RESPONSE,
  payload,
});

export const GETOPPOSITEENVREGION_REQ = (payload) => ({
  type: types.GETOPPOSITEENVREGION_REQ,
  payload,
});

export const GETOPPOSITEENVREGION_RESPONSE = (payload) => ({
  type: types.GETOPPOSITEENVREGION_RESPONSE,
  payload,
});


export const GETMIGRATIONDEFAULTOBJECT_REQ = (payload) => ({
  type: types.GETMIGRATIONDEFAULTOBJECT_REQ,
  payload,
});

export const GETMIGRATIONDEFAULTOBJECT_RESPONSE = (payload) => ({
  type: types.GETMIGRATIONDEFAULTOBJECT_RESPONSE,
  payload,
});


export const GETMIGRATIONOBJECTVALIDATE_REQ = (payload) => ({
  type: types.GETMIGRATIONOBJECTVALIDATE_REQ,
  payload,
});

export const GETMIGRATIONOBJECTVALIDATE_RESPONSE = (payload) => ({
  type: types.GETMIGRATIONOBJECTVALIDATE_RESPONSE,
  payload,
});


export const GETMIGRATIONSTATUSLIST_REQ = (payload) => ({
  type: types.GETMIGRATIONSTATUSLIST_REQ,
  payload,
});

export const GETMIGRATIONSTATUSLIST_RESPONSE = (payload) => ({
  type: types.GETMIGRATIONSTATUSLIST_RESPONSE,
  payload,
});

export const GETMIGRATIONSTART_REQ = (payload) => ({
  type: types.GETMIGRATIONSTART_REQ,
  payload,
});

export const GETMIGRATIONSTART_RESPONSE = (payload) => ({
  type: types.GETMIGRATIONSTART_RESPONSE,
  payload,
});

export const APIKEYVALIDATION_REQ = (payload) => ({
  type: types.APIKEYVALIDATION_REQ,
  payload,
});

export const APIKEYVALIDATION_RESPONSE = (payload) => ({
  type: types.APIKEYVALIDATION_RESPONSE,
  payload,
});


export const GETMODULECOUNT_REQ = (payload) => ({
  type: types.GETMODULECOUNT_REQ,
  payload,
});

export const GETMODULECOUNT_RESPONSE = (payload) => ({
  type: types.GETMODULECOUNT_RESPONSE,
  payload,
});

export const SETMODULECOUNT_REQ = (payload) => ({
  type: types.SETMODULECOUNT_REQ,
  payload,
});

// OIDC Apps action creators
export const FETCH_APPS_REQ = (payload) => ({ type: types.FETCH_APPS_REQ, payload });
export const FETCH_APPS_RESPONSE = (payload) => ({ type: types.FETCH_APPS_RESPONSE, payload });
export const CREATE_APP_REQ = (payload) => ({ type: types.CREATE_APP_REQ, payload });
export const CREATE_APP_RESPONSE = (payload) => ({ type: types.CREATE_APP_RESPONSE, payload });
export const UPDATE_APP_REQ = (payload) => ({ type: types.UPDATE_APP_REQ, payload });
export const UPDATE_APP_RESPONSE = (payload) => ({ type: types.UPDATE_APP_RESPONSE, payload });
export const ROTATE_APP_SECRET_REQ = (payload) => ({ type: types.ROTATE_APP_SECRET_REQ, payload });
export const ROTATE_APP_SECRET_RESPONSE = (payload) => ({ type: types.ROTATE_APP_SECRET_RESPONSE, payload });
export const DISABLE_APP_REQ = (payload) => ({ type: types.DISABLE_APP_REQ, payload });
export const DISABLE_APP_RESPONSE = (payload) => ({ type: types.DISABLE_APP_RESPONSE, payload });
export const ENABLE_APP_REQ = (payload) => ({ type: types.ENABLE_APP_REQ, payload });
export const ENABLE_APP_RESPONSE = (payload) => ({ type: types.ENABLE_APP_RESPONSE, payload });
export const DELETE_APP_REQ = (payload) => ({ type: types.DELETE_APP_REQ, payload });
export const DELETE_APP_RESPONSE = (payload) => ({ type: types.DELETE_APP_RESPONSE, payload });